class SearchDiscoveryResults extends HTMLElement {
  constructor() {
    super();
    this.facetsForm = this.querySelector('.js-facets-form');
    this.sortBy = this.querySelectorAll('.js-sort-by-select');
    this.closeFilters = this.querySelectorAll('.js-close-results-filters');
    this.shade = this.querySelector('.js-results-filters-shade');
    this.showFilters = this.querySelectorAll('.js-show-results-filters');
    this.clearAll = this.querySelectorAll('.js-results-clear-all');
    this.toggleResultsLayoutButton = this.querySelectorAll('.js-toggle-results-layout');
    this.resultsHeroTitle = document.querySelector('.results-hero__title');
    this.mq = window.matchMedia('(max-width: 767px)');
    this.removeFilterButtons = this.querySelectorAll('.js-remove-filter');
    this.timeout;
    this.init();
  }

  init() {
    this.classList.remove('is-loading');

    if (this.facetsForm) {
      this.facetsForm.addEventListener('input', (event) => {

        // Only for desktop
        if (window.matchMedia('(max-width: 767px)').matches) return;

        if (event.target.type === 'checkbox') {
          this.onInput()
        } else {
          if (this.timeout) {
            clearTimeout(this.timeout);
          }

          this.timeout = setTimeout(() => {
            this.onInput()
          }, 300);
        }
      });
    }

    this.closeFilters.forEach((el) => {
      el.addEventListener('click', () => {
        document.body.classList.remove('show-filters');
        this.onInput();
      });
    });

    if (this.shade) {
      this.shade.addEventListener('click', () => {
        document.body.classList.remove('show-filters');
      })
    }

    this.showFilters.forEach((el) => {
      el.addEventListener('click', () => {
        document.body.classList.add('show-filters');
      });
    });

    this.clearAll.forEach((el) => {
      el.addEventListener('click', () => {
        this.clearAllFilters();
      })
    });

    this.removeFilterButtons.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.removeFilter(el.dataset.name);
      })
    });

    this.toggleResultsLayoutButton.forEach((el) => {
      el.addEventListener('click', () => {
        const layout = el.getAttribute('data-results-layout');

        this.toggleResultsLayout(layout);
      })
    });

    if (this.sortBy) {
      this.sortBy.forEach(sortBySelect => {
        sortBySelect.addEventListener('change', (e) => {
          const searchParams = new URL(window.location).searchParams;
          const appendViewAll = searchParams.has('view_all', 'true');

          this.querySelector('.js-sort').value = e.target.value;
          this.onInput(appendViewAll);
        });
      });
    }

    this.addPaginationListeners();
    this.addLoadMoreListeners();
    this.addViewAllListeners();

    this.resizeChecker(this.mq);
    this.mq.addListener(this.resizeChecker.bind(this));
  }

  toggleResultsLayout(layout) {
    if (layout === 'full') {
      this.classList.add('results--items-full-width');
      this.classList.remove('results--items-grid');
    } else if (layout === 'grid') {
      this.classList.add('results--items-grid');
      this.classList.remove('results--items-full-width');
    }
  }

  resizeChecker(mq) {
    if (mq.matches) {
      document.body.classList.add('hide-filters');

      setTimeout(() => {
        document.body.classList.remove('hide-filters');
      }, 250);
    } else {
      document.body.classList.remove('show-filters');
      document.body.classList.remove('hide-filters');
    }
  }

  clearAllFilters() {
    let searchParams = `sort_by=${this.sortBy.value}`

    const searchSettings = this.querySelector('.js-search-settings');

    if (searchSettings) {
      searchSettings.querySelectorAll('input').forEach((input) => {
        searchParams += `&${input.name}=${input.value}`
      })
    }

    const url = `${window.location.pathname}?section_id=search-discovery-results&${searchParams}`;
    this.showProducts(url, searchParams)
  }

  showProducts(url, searchParams, type = 'replace') {
    const isAppend = type === 'load-more' || type === 'view-all';

    if (!isAppend) {
      this.classList.add('is-loading');
    }

    const trigger = type === 'load-more'
      ? this.querySelector('.js-load-more')
      : type === 'view-all'
        ? this.querySelector('.js-view-all')
        : null;

    if (trigger) {
      trigger.classList.add('is-loading');
      trigger.setAttribute('disabled', 'disabled');
    }

    fetch(url)
    .then((res) => {
      return res.text();
    })
    .then((data) => {
      const parser = new DOMParser();
      const resultsHtml = parser.parseFromString(data, "text/html");
      const results = resultsHtml.querySelector('.js-search-discovery-results');
      const resultsCount = resultsHtml.querySelector('.js-results')?.getAttribute('data-results-count');

      if (!isAppend) {
        this.outerHTML = results.innerHTML;
        return;
      }

      const resultsContainer = this.querySelector('.results__grid');
      const newResultsContainer = results.querySelector('.results__grid');
      const loadMore = this.querySelector('.js-load-more');
      const viewAll = this.querySelector('.js-view-all');
      const newLoadMore = results.querySelector('.js-load-more');
      const newViewAll = results.querySelector('.js-view-all');

      if (resultsContainer && newResultsContainer) {
        const existingIds = new Set(
          [...resultsContainer.children].map((item) => item.dataset.productId).filter(Boolean)
        );

        [...newResultsContainer.children].forEach((item) => {
          const id = item.dataset.productId;

          if (!id || !existingIds.has(id)) {
            resultsContainer.appendChild(item.cloneNode(true));
          }
        });
      }

      if (loadMore) {
        if (newLoadMore) {
          loadMore.setAttribute('data-load-more', newLoadMore.getAttribute('data-load-more'));
        } else {
          loadMore.remove();
        }
      }

      if (viewAll) {
        if (newViewAll) {
          // Keep view all button if it exists in the new response
        } else {
          // Remove view all button if it doesn't exist in the new response
          viewAll.remove();
        }
      }

      if (this.resultsHeroTitle && resultsCount) {
        const countEl = this.resultsHeroTitle.querySelector('.results-hero__count');
        if (countEl) {
          countEl.textContent = resultsCount;
        }
      }

      window.history.replaceState({ }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      this.classList.remove('is-loading');

      if (trigger) {
        trigger.classList.remove('is-loading');
        trigger.removeAttribute('disabled');
      }
    });
  }

  onInput(appendViewAll = false) {
    const searchParams = `${new URLSearchParams(new FormData(this.facetsForm)).toString()}${appendViewAll ? '&view_all=true' : ''}`;
    const url = `${window.location.pathname}?section_id=search-discovery-results&${searchParams}`;

    this.showProducts(url, searchParams);
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  addViewAllListeners() {
    const viewAll = this.querySelector('.js-view-all');
    if (!viewAll) return;

    viewAll.addEventListener('click', () => {
      const searchParams = `${new URLSearchParams(new FormData(this.facetsForm)).toString()}&view_all=true`;
      const url = `${window.location.pathname}?section_id=search-discovery-results&${searchParams}`;
      this.showProducts(url, searchParams, 'view-all');
    });
  }

  addLoadMoreListeners() {
    const loadMore = this.querySelector('.js-load-more');

    if (!loadMore) return;

    loadMore.addEventListener('click', () => {
      const page = loadMore.getAttribute('data-load-more');
      const searchParams = `${new URLSearchParams(new FormData(this.facetsForm)).toString()}&page=${page}`;
      const url = `${window.location.pathname}?section_id=search-discovery-results&${searchParams}`;
      this.showProducts(url, searchParams, "load-more");
    });
  }

  addPaginationListeners() {
    const pagination = this.querySelectorAll('.js-pagination');
    pagination.forEach((el) => {
      const page = el.getAttribute('data-page');
      if (!page) return;
      
      const currentParams = new URLSearchParams(window.location.search);
      const formParams = new URLSearchParams(new FormData(this.facetsForm));
      formParams.forEach((value, key) => {
        currentParams.set(key, value);
      });
      
      currentParams.set('page', page);
      currentParams.delete('section_id');
      
      const searchParams = currentParams.toString();
      const url = `${window.location.pathname}?section_id=search-discovery-results&${searchParams}`;
      el.href = `${window.location.pathname}?${searchParams}`;
      el.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo(0, 0);
        this.showProducts(url, searchParams);
      });
    });
  }

  removeFilter(filter) {
    const checkbox = this.facetsForm.querySelector(`.facets__checkbox[value="${filter}"]`);
    if (checkbox) {
      checkbox.checked = false;
      this.onInput();
    }
  }
}

customElements.define('search-discovery-results', SearchDiscoveryResults);
